<app-loading-spinner [isLoading]="daveningService.loading()"></app-loading-spinner>
<div class="container">
  <h2>Please check your email for a 4-digit code</h2>

  <form (ngSubmit)="submitForm()" #codeForm="ngForm" class="code-form">
    <div class="code-inputs">
      <input type="text" autocomplete="off" maxlength="1" pattern="[0-9]*" inputmode="numeric" required [(ngModel)]="code[0]" name="code0" (input)="onInput($event, 0)" (keydown)="onKeyDown($event, 0)">
      <input type="text" autocomplete="off" maxlength="1" pattern="[0-9]*" inputmode="numeric" required [(ngModel)]="code[1]" name="code1" (input)="onInput($event, 1)" (keydown)="onKeyDown($event, 1)">
      <input type="text" autocomplete="off" maxlength="1" pattern="[0-9]*" inputmode="numeric" required [(ngModel)]="code[2]" name="code2" (input)="onInput($event, 2)" (keydown)="onKeyDown($event, 2)">
      <input type="text" autocomplete="off" maxlength="1" pattern="[0-9]*" inputmode="numeric" required [(ngModel)]="code[3]" name="code3" (input)="onInput($event, 3)" (keydown)="onKeyDown($event, 3)">
    </div>

    <button class="btn btn-ok" type="submit" [disabled]="!isCodeComplete()">Submit</button>
  </form>
</div>